import { apolloProvider } from './api/apollo';
import { editorViewStore } from './store/editor-view.store';

export const editorViewVueInstanceOptions = {
  el: '#editor-view-app',
  store: editorViewStore,
  apolloProvider,
  render: h =>
    h('div', {
      attrs: {
        id: 'editor-view-app',
      },
    }),
};
